import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PartyEventsService} from "@portal/api/party-events-service";
import {PartyEventResponse} from "@portal/api/responses/PartyEvents/party-event-response";
import { Location, DatePipe } from "@angular/common";
import {ActivatedRoute} from "@angular/router";
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-event-drawer-header',
    templateUrl: './event-drawer-header.component.html',
    styleUrls: ['./event-drawer-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButton, MatIcon, DatePipe]
})
export class EventDrawerHeaderComponent implements OnInit {
    partyEvent: PartyEventResponse;
    mode = "Adicionar"
    pageTitle: string;
    constructor(private _partyEventsService: PartyEventsService,
                private route: ActivatedRoute,
                private location: Location) {

    }

    ngOnInit(): void {
        this.route.data.subscribe(data => {
            this.mode = data.add ? 'Adicionar' : 'Editar';
            this.pageTitle = data.pageTitle;
        });


        this.partyEvent = this._partyEventsService.getCurrentEvent();
    }


    goBack() {
        this.location.back();
    }
}
